import {
  createContext,
  useContext,
  useReducer,
  type Dispatch,
  type ReactNode,
} from 'react'
import {
  gameReducer,
  initialGameState,
  type GameAction,
  type GameStateData,
} from './gameReducer'
import { useGameHub } from './useGameHub'

interface GameContextValue {
  state: GameStateData
  dispatch: Dispatch<GameAction>
  invoke: (method: string, ...args: unknown[]) => Promise<void>
}

const GameContext = createContext<GameContextValue | null>(null)

export function GameStateProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(gameReducer, initialGameState)
  const { invoke } = useGameHub(dispatch)

  return <GameContext.Provider value={{ state, dispatch, invoke }}>{children}</GameContext.Provider>
}

export function useGameState() {
  const ctx = useContext(GameContext)

  if (!ctx) {
    throw new Error('useGameState must be used within GameStateProvider')
  }

  return ctx
}
